import { format, parseISO } from 'date-fns';

export const formatDisplayDate = (dateString: string): string => {
    if (!dateString) return '';

    try {
        const date = parseISO(dateString);
        return format(date, 'd MMMM yyyy');
    } catch (error) {
        console.warn('Failed to parse date:', dateString, error);
        return 'Invalid Date';
    }
};

export const formatCompactDate = (dateString: string): string => {
    if (!dateString) return '';

    try {
        const date = parseISO(dateString);
        return format(date, 'd MMM yy');
    } catch (error) {
        console.warn('Failed to parse date:', dateString, error);
        return 'Invalid Date';
    }
};

export const formatDateWithTime = (dateString: string): string => {
    if (!dateString) return '';

    try {
        const date = parseISO(dateString);
        return format(date, 'd MMMM yyyy, h:mm a');
    } catch (error) {
        console.warn('Failed to parse date:', dateString, error);
        return 'Invalid Date';
    }
};

export const formatEventDateRange = (startDate?: string, endDate?: string): string => {
    if (!startDate && !endDate) return '';
    if (!startDate) return endDate ? formatDisplayDate(endDate) : '';
    if (!endDate) return formatDisplayDate(startDate);

    try {
        const start = parseISO(startDate);
        const end = parseISO(endDate);

        if (startDate === endDate || format(start, 'yyyy-MM-dd') === format(end, 'yyyy-MM-dd')) {
            return format(start, 'd MMMM yyyy');
        }

        if (format(start, 'yyyy') === format(end, 'yyyy')) {
            return `${format(start, 'd MMMM')} - ${format(end, 'd MMMM yyyy')}`;
        }

        return `${format(start, 'd MMMM yyyy')} - ${format(end, 'd MMMM yyyy')}`;
    } catch (error) {
        console.warn('Failed to parse event date range:', { startDate, endDate }, error);
        return 'Invalid Date Range';
    }
};
